export default __webpack_public_path__ + "static/media/checked.6f298cca.png";